import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { makeHeaderRow } from '../../utils/goal_statics';
import BondsDeptsStaticsEmpTable from '../../components/bonds-depts-statics/BondsDeptsStaticsEmpTable';
import * as staticsApi from '../../lib/api/statics';

const BondsDeptsStaticsEmployee = ({
  selectedYear,
  strMonth,
  endMonth,
  tableRef,
  searchDate,
  selectedGbn,
  selectPrjTyp,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [headerRows, setHeaderRows] = useState(null);

  const onLoadData = async () => {
    setLoading(true);

    try {
      const loadedHeaders = makeHeaderRow(strMonth, endMonth);
      setHeaderRows(loadedHeaders);
      const res = await staticsApi.getEmpBondsDeptsStatics(
        selectedYear,
        strMonth,
        endMonth,
        selectedGbn,
        selectPrjTyp,
        { procCompYn: 'N' },
      );
      if (res.data.list) {
        setData(res.data.list);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (searchDate) {
      onLoadData();
    }
  }, [searchDate]);

  return (
    <BondsDeptsStaticsEmpTable
      data={data}
      loading={loading}
      headerRows={headerRows}
      tableRef={tableRef}
      selectedGbn={selectedGbn}
    />
  );
};

export default BondsDeptsStaticsEmployee;
